
import { Options, Vue } from "vue-class-component";
import { GTMCommonEvent } from "@/app/infrastructures/misc/gtm-event/common-event";

@Options({
  components: {}
})
export default class PosFavourite extends Vue {
  // Tabs
  tabs = [
    { name: "member", title: "Member", titleKey: "posFavourite.member", testId: "pos-favorite-tab-member" },
    { name: "outstanding-member", title: "Tagihan Member", titleKey: "posFavourite.outstandingMember", testId: "pos-favorite-tab-outstanding" }
  ];

  changeTabs(value: string) {
    this.$router.push({
      name: value
    });

    const eventName =
      value === "member"
        ? "pos_langganan_member"
        : "pos_langganan_tagihan_member";
    GTMCommonEvent(eventName);
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }
}
